'use strict';
/**
 * Created by Qui Huynh on 21/09/2017.
 */
angular
    .module('app.newInfluencers')
    .controller('RegisterUserInfoModalCtrl', [
        '$state',
        '$scope',
        '$rootScope',
        '$modalInstance',
        '$modal',
        'adminService',
        'userManagementService',
        'AuthenticationService',
        function ($state, $scope, $rootScope, $modalInstance, $modal, adminService, userManagementService, AuthenticationService) {
            var me = this;

            var def = angular.copy($rootScope.definitions);
            me.countries = def.countries;
            me.languages = def.languages;

            var showError = function(error) {
                $rootScope.handleRequestError({message: error}, $scope);
            };

            var closeModal = function() {
                $modalInstance.close();
            };

            var save = function() {
                if (me.form.$invalid) {
                    showError('Please input all required fields.');
                }
                else {
                    var user = angular.copy(me.user);
                    if (user.address.country && user.address.country[0]) {
                        user.address.country = user.address.country[0].id;
                    }
                    if (user.languages && user.languages[0]) {
                        var id = user.languages[0].id;
                        user.languages = [];
                        user.languages.push(id);
                    }


                    /*$rootScope.currentUser.userStatus.id = 3;
                    closeModal();
                    AuthenticationService.reloadCurrentUser()*/

                    userManagementService.updateProfile(user, true) 
                        .then(function(res){
                            closeModal();
                            AuthenticationService.reloadCurrentUser();
                        }, function (err) {
                            $rootScope.handleRequestError(err, $scope);
                        });
                }
            };

            var onCountrySelect = function(country) {
                adminService.getCountryLanguage(country.id, false) 
                    .then(function(res){
                        if (res && res.data) {
                            for (var i=0; i < me.languages.length; i++) {
                                me.languages[i].ticked = false;
                                if (res.data.id === me.languages[i].id) {
                                    me.languages[i].ticked = true;
                                }
                            }
                        }
                    }, function (err) {
                        $rootScope.handleRequestError(err, $scope);
                    });
            };

            var onConfirmPassword = function (password, confirmPassword) {
                var value = password === confirmPassword;
                me.form.confirmPassword.$setValidity('missMatch', value);
            };

            var mapDropdownListById = function(dropdownList, id) {
                for (var i=0; i < dropdownList.length; i++) {
                    if (id === dropdownList[i].id) {
                        dropdownList[i].ticked = true;
                        break;
                    }
                }
            };

            var mapUserInfo = function(userInfo) {
                me.user = {
                    name: userInfo.fullName,
                    email: userInfo.email,
                    address: {
                        id: userInfo.address && userInfo.address[0] && userInfo.address[0].id,
                        country: userInfo.country && userInfo.country.id,
                        address: userInfo.address && userInfo.address[0] && userInfo.address[0].address,
                        zipCode: userInfo.address && userInfo.address[0] && userInfo.address[0].zipCode,
                        city: userInfo.address && userInfo.address[0] && userInfo.address[0].city
                    },
                    phone: userInfo.phone,
                    languages: userInfo.languages
                };

                if (userInfo.country && userInfo.country.id) {
                    mapDropdownListById(me.countries, userInfo.country.id);
                }
                if (userInfo.languages && userInfo.languages[0] && userInfo.languages[0].id) {
                    mapDropdownListById(me.languages, userInfo.languages[0].id);
                }
                else {
                    if (userInfo.country && userInfo.country.id) {
                        onCountrySelect(userInfo.country);
                    }
                }

            };

            var getInfluencerLanguages = function(){
                var influencerLanguages = [];

                if ($rootScope.influencerInformation && $rootScope.influencerInformation.influencerLanguages){
                    var languages = $rootScope.influencerInformation.influencerLanguages;

                    for (var i = 0; i < languages.length; i++){
                        if (languages[i].language){
                            influencerLanguages.push(languages[i].language);
                        }
                    }
                }

                return influencerLanguages;
            };

            (function init() {
                me.currentUser = $rootScope.currentUser;
                if (me.currentUser.languages == null || me.currentUser.languages.length == 0){
                    me.currentUser.languages = getInfluencerLanguages();
                }

                me.closeModal = closeModal;
                me.save = save;
                me.onCountrySelect = onCountrySelect;
                me.onConfirmPassword = onConfirmPassword;
                mapUserInfo(me.currentUser);

            })();
        }
]);